import { createAction } from '../utils/store';

export const restart = createAction('RESTART');
